module.exports = __webpack_public_path__ + "static/media/iv_childs_wedding.c8e599be.svg";